import "core-js/modules/es.array.reduce.js";
import { defineStore } from "pinia";
import { ref } from "vue";
//@ts-ignore
import { useCommonVars } from "@wkComposables/useCommonVars";
//@ts-ignore
import { useSearchBeanStore } from "@store/SearchBeanStore";
export var useListingTypologyStore = defineStore("listingTypologyStoreId", () => {
  var typologiesObj = ref({});
  var macroTypologiesObj = ref({});
  var singleTypologies = ref({});
  var typologyId_macroTypologyId = ref({});
  var selectedTypologiesLabel = ref("");
  var typologiesSelected = ref([]);
  var isInit = false;
  var {
    wkLabels
  } = useCommonVars();
  var sbs = useSearchBeanStore();
  var updateSelectedLabel = () => {
    if (!typologiesSelected.value.length) return;
    var _group = macroTypologiesObj.value[typologiesSelected.value[0].macroTypologyID];
    //Case 0: All typologies selected
    if (typologiesSelected.value.length === 1 && typologiesSelected.value[0].allTypologies) {
      selectedTypologiesLabel.value = "".concat(_group.group, " - ").concat(wkLabels.value["allTypologies"]);
    }
    //Case 1: Single typology selected
    else if (typologiesSelected.value.length === 1) {
      selectedTypologiesLabel.value = typologiesSelected.value[0].label;
    }
    //Case 2: Multiple typologies selected
    else if (typologiesSelected.value.length > 1) {
      selectedTypologiesLabel.value = "".concat(_group.group, " - ").concat(typologiesSelected.value.length, " ").concat(wkLabels.value.typologies);
    }
  };
  var initTypologiesObj = _listingTypologies => {
    var _a;
    typologiesObj.value = (_a = _listingTypologies.reduce((acc, cur) => {
      //The current checkbox is "All typologies"
      //The reset property will be used by the checkbox group, so it will reset (uncheck) all the other checkboxes
      cur.reset = cur.label === wkLabels.value.allTypologies;
      cur.allTypologies = cur.label === wkLabels.value.allTypologies;
      var _macroTypologyId = cur.macroTypologyID;
      //Initializing the macroTypologies object
      if (cur.allTypologies) {
        macroTypologiesObj.value[_macroTypologyId] = cur;
      }
      //In this case we are dealing with single typologies. E.g: stanze e camere, nuove costruzioni ....
      if (!cur.group) singleTypologies.value[cur.listingTypologyId] = cur;
      //In this case we are dealing with a macroTypology
      else {
        typologyId_macroTypologyId.value[cur.listingTypologyId] = cur.macroTypologyID;
        if (!acc[_macroTypologyId]) acc[_macroTypologyId] = {
          [cur.listingTypologyId]: cur
        };else acc[_macroTypologyId][cur.listingTypologyId] = cur;
      }
      return acc;
    }, {})) !== null && _a !== void 0 ? _a : {};
  };
  var initTypologiesSelected = () => {
    var _a;
    (_a = sbs.searchBean.listingTypologyIdList) === null || _a === void 0 ? void 0 : _a.forEach(selectedListingTypologyId => {
      //Pick its macroTypology if exists
      var _macroTypologyId = typologyId_macroTypologyId.value[selectedListingTypologyId];
      //If we don't find a macroTypology id, the selected listing typology id could be a single typology!
      if (!_macroTypologyId)
        //Adding single typology to selected typologies
        typologiesSelected.value.push(singleTypologies.value[selectedListingTypologyId]);else {
        var typologyToSelect = typologiesObj.value[_macroTypologyId][selectedListingTypologyId];
        //Adding typology to selected typologies
        typologiesSelected.value.push(typologyToSelect);
        //Checking typology - needed for the checkbox
        typologyToSelect.checked = true;
      }
    });
  };
  var initListingTypologyStore = function initListingTypologyStore(_listingTypologies) {
    var updateLabel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (isInit) return;
    initTypologiesObj(_listingTypologies);
    initTypologiesSelected();
    if (updateLabel) updateSelectedLabel();
    isInit = true;
  };
  var $reset = () => {
    isInit = false;
    typologiesObj.value = {};
    macroTypologiesObj.value = {};
    singleTypologies.value = {};
    typologyId_macroTypologyId.value = {};
    selectedTypologiesLabel.value = "";
    typologiesSelected.value = [];
  };
  return {
    singleTypologies,
    selectedTypologiesLabel,
    macroTypologiesObj,
    typologiesSelected,
    typologiesObj,
    updateSelectedLabel,
    initListingTypologyStore,
    $reset
  };
});